import { Dispatch, Store } from "redux";
import { toggleModal } from "src/store/actions/openModal";
import { deleteVehicleRequest } from "src/store/actions/vehicles";
import { isLockedPricingSetup } from "src/store/selectors/account";
import { ApplicationStore } from "Types/state";

const reportableTypes: any[] = [toggleModal.type];

const handleGarageCleanup = (store: Store) => {
    if (!store || !store.getState || !store.dispatch) return;
    const currentStore: ApplicationStore = store.getState();

    // Basically "catastrophic" states for our app to be in, where we really shouldn't be messing with the dispatch over and over.
    // Generally happens when issues with network requests occur.
    // Because this middleware doesn't really play within the rules of our application, these checks are helpful.
    if (!currentStore || !currentStore.account || !currentStore.account.slug) return;
    if (!currentStore.deal || !currentStore.deal.uuid) return;

    // Checks if the app is open and user is not authenticated.  If they are, we leave their vehicles alone -- they already have a real garage.
    if (!currentStore.onlineShopper || !currentStore.onlineShopper.isAppOpen) return;

    if (isLockedPricingSetup(currentStore) && currentStore.onlineShopper.garageCreated) {
        return;
    }

    if (
        isLockedPricingSetup(currentStore) &&
        (currentStore.deal.person?.email || currentStore.deal.person?.mobile_phone) &&
        currentStore.vehicles.order.length === 1
    ) {
        return;
    }

    if (
        !isLockedPricingSetup(currentStore) &&
        (currentStore.deal.person?.email || currentStore.deal.person?.mobile_phone)
    ) {
        return;
    }

    if (!(currentStore.vehicles && currentStore.vehicles.order.length > 0)) {
        return;
    }

    const vin = currentStore.onlineShopper.toggledVin;

    if (!vin) {
        return;
    }

    void store.dispatch(deleteVehicleRequest(currentStore.deal.uuid, vin));
};

/**
 * Custom middleware to remove the vehicle selected if a garage wasn't created.
 * Listens to user path: click on vehicle, close modal without hitting save
 * @param store Current state of the application.
 */
const garageManagement = (store: any) => (next: Dispatch) => (action: any) => {
    if (action && typeof action !== "function" && reportableTypes.includes(action.type.toString())) {
        handleGarageCleanup(store);
    }
    next && action && next(action);
};

export default garageManagement;
export { handleGarageCleanup };
